<template>
  <div>
    <base-header class="pb-6 pb-8 pt-8 pt-md-5">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="col-xl-12 order-xl-1">
            <card shadow>
              <template #header>
                <div class="border-0">
                  <div class="row align-items-center">
                    <div class="col-8 text-start">
                      <h5 v-if="!isUpdate" class="mb-0">New Client</h5>
                      <h5 v-else class="mb-0">Update Client</h5>
                    </div>
                  </div>
                </div>
              </template>
              <form>
                <div class="text-start fw-bolder text-uppercase text-muted">Personal details </div>
                <hr class="mt-0">
                <div class="ps-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.firstName"
                          alternative=""
                          :label="$t('First name')"
                          :placeholder="$t('First name')"
                          input-classes="form-control-alternative"
                          :error="v$.model.firstName.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.lastName"
                          alternative=""
                          :label="$t('Last name')"
                          :placeholder="$t('Last name')"
                          input-classes="form-control-alternative"
                          :error="v$.model.lastName.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.identityCardNumber"
                          alternative=""
                          :label="$t('Identity card number')"
                          :placeholder="$t('Identity card number')"
                          input-classes="form-control-alternative"
                      />
                    </div>
                    <div v-if="!isUpdate" class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label float-start">{{ $t("Phone number") }}</label>
                        <base-input
                            v-model="model.phoneNumber"
                            type="number"
                            form-classes="input-group-alternative mb-3 phone-input"
                            style="display: flex;border-radius: 0;"
                            :placeholder="$t('Contact Phone')"
                            :error="v$.model.phoneNumber.$errors.map( err => { return err.$message })[0]"
                        >
                          <template #addonLeft>
                            <multiselect
                                v-model="model.phoneNumberCode"
                                :options="countryCodes"
                                placeholder=""
                                :show-labels="false"
                                :searchable="true"
                                :custom-label="customLabel"
                                required
                                :multiple="false"
                                class=""
                            >
                              <template #singleLabel="{ option }">
                                <img v-if="option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+option.iso.toUpperCase()+'.png')" />
                                <span class="ps-1" style="line-height: 31px">{{ option.code }}</span>
                              </template>
                              <template #option="props">
                                <img v-if="props.option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+props.option.iso.toUpperCase()+'.png')" />
                                {{ props.option.text }}
                              </template>
                            </multiselect>
                          </template>
                          <template #infoBlock>
                            <span class="w-100 text-sm text-muted">{{ $t("Will be used for authentication.") }}</span>
                          </template>
                        </base-input>
                    </div>
                    </div>
                    <div class="col-lg-6 text-start">
                      <label class="form-control-label ">{{ $t("Preferred language") }} </label>
                      <multiselect
                          v-model="model.contactLanguage"
                          :options="['en','el']"
                          :placeholder="$t('Select language')"
                          :show-labels="false"
                          required
                          class=""
                      >
                        <template #singleLabel="{ option }">{{ $t(option) }}</template>
                        <template #option="props">
                          {{ $t(props.option) }}
                        </template>
                      </multiselect>
</div>
                    <div v-if="!isUpdate" class="col-lg-6">
                      <base-input
                          v-model="model.email"
                          alternative=""
                          label="Email address"
                          placeholder="Email address"
                          input-classes="form-control-alternative"
                          :error="v$.model.email.$errors.map( err => { return err.$message })[0]"
                      >
                      </base-input>
                    </div>
                    <div v-if="userRole === 'system'" class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label">{{ $t("Status") }} </label>
                        <multiselect
                            v-model="model.status"
                            :options="['verified', 'pending', 'disabled']"
                            :placeholder="$t('Select status')"
                            :show-labels="false"
                            required
                            class=""
                        >
                          <template #singleLabel="{ option }">{{ $t(option) }}</template>
                          <template #option="props">
                            {{ $t(props.option) }}
                          </template>
</multiselect>
                      </div>
                    </div>
                  </div>
                  </div>
<!--                <div class="text-start fw-bolder text-uppercase text-muted">Contact details </div>-->
<!--                <hr class="mt-0">-->
<!--                <div class="ps-lg-4">-->
<!--                  <div class="row">-->
<!--&lt;!&ndash;                    <base-input&ndash;&gt;-->
<!--&lt;!&ndash;                        v-model="model.contactEmail"&ndash;&gt;-->
<!--&lt;!&ndash;                        alternative=""&ndash;&gt;-->
<!--&lt;!&ndash;                        label="Contact email"&ndash;&gt;-->
<!--&lt;!&ndash;                        placeholder="Contact email"&ndash;&gt;-->
<!--&lt;!&ndash;                        input-classes="form-control-alternative"&ndash;&gt;-->
<!--&lt;!&ndash;                        :error="v$.model.contactEmail.$errors.map( err => { return err.$message })[0]"&ndash;&gt;-->
<!--&lt;!&ndash;                    />&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="col-lg-6">&ndash;&gt;-->
<!--&lt;!&ndash;                      <base-input&ndash;&gt;-->
<!--&lt;!&ndash;                          v-model="model.contactPhone"&ndash;&gt;-->
<!--&lt;!&ndash;                          alternative=""&ndash;&gt;-->
<!--&lt;!&ndash;                          label="Contact phone"&ndash;&gt;-->
<!--&lt;!&ndash;                          placeholder="+357 99887766"&ndash;&gt;-->
<!--&lt;!&ndash;                          input-classes="form-control-alternative"&ndash;&gt;-->
<!--&lt;!&ndash;                      />&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="col-lg-6">&ndash;&gt;-->
<!--&lt;!&ndash;                      <base-input&ndash;&gt;-->
<!--&lt;!&ndash;                          v-model="model.contactPhone2"&ndash;&gt;-->
<!--&lt;!&ndash;                          alternative=""&ndash;&gt;-->
<!--&lt;!&ndash;                          label="Secondary Contact phone"&ndash;&gt;-->
<!--&lt;!&ndash;                          placeholder="+357 99887766"&ndash;&gt;-->
<!--&lt;!&ndash;                          input-classes="form-control-alternative"&ndash;&gt;-->
<!--&lt;!&ndash;                      />&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--                  </div>-->
<!--                </div>-->
                <div class="text-start fw-bolder text-uppercase text-muted">Address details </div>
                <hr class="mt-0">
                <div class="ps-lg-4">
<div class="row">
                    <div class="col-md-6">
                      <base-input
                          v-model="model.address.street"
                          alternative=""
                          label="Street"
                          placeholder="Home Address"
                          input-classes="form-control-alternative"
                          :error="v$.model.address.street.$errors.map( err => { return err.$message })[0]"
                      />
</div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.address.city.$error }">
                        <label class="form-control-label">{{ $t('City') }}</label>

                        <multiselect
                            v-model="model.address.city"
                            :show-labels="false"
                            deselect-label="Can't remove this value"
                            placeholder="Select city"
                            :options="cities"
                            :searchable="false"
                            :custom-label="customCityLabel"
                        >
                        </multiselect>

                        <div v-if="v$.model.address.city.$error" class="text-danger invalid-feedback" style="display: block;">
                          {{ v$.model.address.city.$errors.map( err => { return err.$message })[0] }}
                        </div>
</div>
                    </div>
                    <div class="col-lg-4">
                      <base-input
                          v-model="country"
                          disabled="true"
                          alternative=""
                          :label="$t('Country')"
                          :placeholder="$t('Country')"
                          input-classes="form-control-alternative"
/>
                    </div>
                    <div class="col-lg-4">
                      <base-input
                          v-model="model.address.postCode"
                          alternative=""
                          label="Post code"
                          placeholder="Post code"
                          input-classes="form-control-alternative"
                          :error="v$.model.address.postCode.$errors.map( err => { return err.$message })[0]"
/>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-end">
                  <base-button v-if="!isUpdate" class="me-2" outline type="info" @click="clearForm">Reset</base-button>
                  <submit-button :alert-message="errorMessage" :state="loadingProcess" @clicked="submitClient">{{ isUpdate ? 'Update' : 'Submit' }}</submit-button>
                </div>
              </form>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import useVuelidate from "@vuelidate/core"
import {helpers, required, email, requiredIf, minLength, maxLength} from "@vuelidate/validators"
import {isValidNumber, getCountries, getCountryCallingCode, parsePhoneNumber} from "libphonenumber-js"
import {isoCountryCodeToFlagEmoji, isWindows} from "@/helpers/common"
import BaseInput from "@/components/BaseInput.vue"
import BaseButton from "@/components/BaseButton.vue"
import SubmitButton from "@/components/SubmitButton.vue"
const isValidPhone = (param) => helpers.withParams(
    { type: "isValidPhone", value: param }, (value) => {

  if (value == null || value === ""){
    return true
  }
  console.log("param+value", param+value)
  return isValidNumber(param+value)
})

export default {
  name: "newClient",
  components: {SubmitButton, BaseButton, BaseInput},
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      isWindows,
      countryCodes: [],
      errorMessage: "",
      loadingProcess: "",
      loadingMessage: "",
      cities: ["LIMASSOL", "NICOSIA", "LARNACA", "PAPHOS", "AMOCHOSTOS"],
      country: "Cyprus",
      model: {
        phoneNumber: null,
        phoneNumberCode: {code: "+357", text: this.$t("CY") + " +357", iso: "CY"},
        status: "active",
        firstName: "",
        lastName: "",
        contactLanguage: "en",
        email: null,
        identityCardNumber: null,
        address: {
          street: "",
          city: "",
          postCode: "",
          locality: "",
          countryCode: "CY",
        },
      },
    }
  },
  validations () {
    return {
      model: {
        address: {
          street: {
            required: helpers.withMessage(this.$t("Value is required"), required)
          },
          city: {
            required: helpers.withMessage(this.$t("Value is required"), required)
          },
          postCode: {
            required: helpers.withMessage(this.$t("Value is required"), required),
            minLength: minLength(4),
            maxLength: maxLength(4),
          },
        },
        phoneNumber: {
          validated: helpers.withMessage(this.$t("Must be valid phone number."), isValidPhone(this.model.phoneNumberCode?.code)),
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(!this.isUpdate))
        },
        firstName: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        lastName: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        email: {
          email: email,
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.isUpdate))
        },
      },
    }
  },
  computed: {
    isUpdate() {
      return ["editClientAccount", "editClient"].includes(this.$route.name)
    },
    userRole(){
      return this.$store.state.user?.claims?.role ?? null
    }
  },
  async mounted() {
    let clientId
    if (this.userRole === "system" && this.$route.params.hasOwnProperty("id")) {
      clientId = this.$route.params.id
    } else if (this.userRole === "client") {
      clientId = this.$store.state.user.claims.user_id
    }
    if (clientId) {
      this.isUpdate = true
      await this.getClient(clientId)
    }
    let countries = ["CY", "GB", "GR"]

    countries.forEach(country => {
      let code = getCountryCallingCode(country)
      this.countryCodes.push({code: "+" + code, text: this.$t(country) + " +" + code, iso: country})
    })
  },
  methods: {
    customLabel(option) {
      return `${option.text}`
    },
    isoCountryCodeToFlagEmoji,
    customCityLabel (option) {
      return this.$t(option)
    },
    async getClient(id) {
      this.model = await this.$store.dispatch("fetchClient", id)
      this.model.phoneNumber = null
      // if (this.model.phoneNumber !== null) {
      //   let phoneDetails = parsePhoneNumber(this.model.phoneNumber)
      //   this.model.phoneNumber = phoneDetails.nationalNumber ?? null
      //   this.model.phoneNumberCode = {code: phoneDetails.countryCallingCode ?? "+357", text: this.$t(phoneDetails.country ?? "CY") + " " + phoneDetails.countryCallingCode, iso: phoneDetails.country ?? "CY"}
      // }

      if (!Object.hasOwn(this.model, "address")){
        this.model.address = {
          street: "",
          city: "",
          postCode: "",
          locality: "",
          countryCode: "CY",
        }
      }
      console.log("model", this.model)
    },
    async submitClient() {
      let self = this

      this.v$.$touch()

      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors)
        return
      }


      let payload = {}
      if (this.isUpdate) {
        payload = {
          id: this.$route.params.id,
          status: this.model.status,
          contactLanguage: "en",
          firstName: this.model.firstName,
          lastName: this.model.lastName,
          identityCardNumber: this.model.identityCardNumber,
          address: {
            countryCode: "CY",
            city: this.model.address.city,
            street: this.model.address.street,
            postCode: this.model.address.postCode,
          },
        }
      } else {
        payload = {
          status: this.model.status,
          address: {
            countryCode: "CY",
            city: this.model.address.city,
            street: this.model.address.street,
            postCode: this.model.address.postCode,
          },
          contactLanguage: this.model.contactLanguage,
          firstName: this.model.firstName,
          lastName: this.model.lastName,
          email: this.model.email,
          identityCardNumber: this.model.identityCardNumber,
        }
      }

      if (this.model.phoneNumber != null && this.model.phoneNumber !== ""){
        console.log("this.model.phoneNumber INNN")
        payload.phoneNumber = this.model.phoneNumberCode.code + this.model.phoneNumber
      }
      console.log("payload", payload)

      this.loadingProcess = "processing"

      FirebaseFunctionsHelper.callFunction(
          this.isUpdate ? "client-update" : "client-create",
          // eslint-disable-next-line no-undef
         payload
      )
          .then((result) => {
            console.log("res", result)
            // eslint-disable-next-line no-prototype-builtins
            if (result != null && result.hasOwnProperty("message")) {
              console.log("result message", result.message)
              self.loadingProcess = "failed"
              self.errorMessage = result.message
              return
            }
            console.log("submitUser result", result)
            this.loadingProcess = "done"

            if (!this.isUpdate) {
              this.$router.push({ path: "/clients/"+result+"/info" })
            } else {
              if (this.userRole === "client"){
                this.$router.push({ path: "/account/info"})
                return
              }
              this.$router.push({ path: "/clients/"+this.$route.params.id + "/info"})
            }

          })
          .catch((error) => {
            self.loadingProcess = "failed"
            self.errorMessage = error.message
            console.log("submitUser error", error)
          })

      // setTimeout(() => {
      //   this.loadingProcess = "failed";
      //   this.loadingMessage = "There was an error.";
      //   //Add Tokens
      // }, 2000);
    },
    clearForm() {
      this.loadingProcess = ""
      if (this.dbUser){
        this.model = this.dbUser
      } else {
        this.model = {
          phoneNumber: null,
          phoneNumberCode: {code: "+357", text: this.$t("CY") + " +357", iso: "CY"},
          status: "active",
          contactLanguage: "",
          identityCardNumber: null,
          firstName: "",
          lastName: "",
          email: "",
          address: {
            street: "",
            countryCode: "CY",
            city: "",
            lat: 0,
            long: 0 ,
            postCode: "",
            locality: "",
          }
        }
      }
    },
    getValueOrDefault(obj, prop, defaultValue){
      return Object.prototype.hasOwnProperty.call(obj, prop) ? (obj[prop] || defaultValue) : defaultValue
    }
  },
}
</script>
<style scoped>
.form-group.has-label {
  padding-top: 0.5rem !important;
}
</style>
